import { useEffect, useState } from "react";
import { FinanceService } from '../../../../core/services/FinanceService';
import {  ButtonHealthID } from './ButtonHealthID';
import { HealthIDChilds } from './HealthIDChilds';
import { BasicButton } from "../../../theme/Component/BasicButton";
import { useDashboardStore } from "../../../pages/hooks/useDashboardStore";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { SelectExpensiveBudgetIDType } from "../select/SelectExpensiveBudgetIDType";
import { Modal } from "../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { FileInput } from "../../../theme/Component/FileInput";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _ImpHealthIDCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

interface Props {
  crud?: boolean,
  tipoPresupuesto: number | null;
  id: number | null;
  edit: boolean;
  isExpensive?: boolean;
  year?: number;
  onSelect?: (item: any) => void;
}
export const HealthID = ({ id, edit, tipoPresupuesto, isExpensive, year, onSelect ,crud }: Props) => {
  const service = new FinanceService();
  const { setLoading } = useDashboardStore();
  const imp = useDataBean(_ImpHealthIDCatalog);
  const [lista, setLista] = useState([]);
  const [listaType, setListaType] = useState([]);
  const [txt, setTxt] = useState<string>('');
  const [bean, setBean] = useState<any>({});
  const [type, setType] = useState(0);
  const [typetwo, setTypetwo] = useState(0);
  const [modalAdd, setModalAdd] = useState<any>({ name: 'Agregar Item', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
  const [modaladddoc, setModaladddoc] = useState<any>({ name: 'Agregar Item', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
  const [idchild, setIDchild] = useState(0);

  useEffect(() => {

    if (tipoPresupuesto) {
      setType(tipoPresupuesto);
    }
    getListaType();

    getSeparator();
  }, []);

  useEffect(() => {
    getListaType();
    console.log(type);

  }, [type])

  const createBean = () => {
    if (bean.Code && bean.Name) {
      setLoading(true);
      service.createHealthID(type, bean.Code, bean.Name).subscribe(
        (resp: any) => {
          getListatree();
          _single.create(bean);
          setIDchild(0)
          _single.deleteCacheItem("budgetChild_")
          _single.deleteCacheItem("treeBusget_")
          setLoading(false);
        }
      );
      setModalAdd({ ...modalAdd, 'view': false });
    } else {
      toast.error('Código y Nombre son obligatorios');
    }
  }

  const getListaType = () => {

    setLoading(true);
    service.getHealthIDTypeCatalog(type || null).subscribe((resp: any) => {
      if (resp.DataBeanProperties.ObjectValue) {
        let arbol: any = resp.DataBeanProperties.ObjectValue;

        setListaType(resp.DataBeanProperties.ObjectValue);
        _single.setCacheItem('TypeBudget', JSON.stringify(resp.DataBeanProperties.ObjectValue));
      }
      setLoading(false);
    });

  };
  const getListatree = () => {
    let tmp = _single.getCacheItem('getCacheItem_' + type);
    if (false)
      setLista(JSON.parse(tmp));
    else {
      setLoading(true);
      service.getTreeForHealthID(type).subscribe((resp: any) => {

        if (resp.DataBeanProperties.ObjectValue) {
          let arbol: any = resp.DataBeanProperties.ObjectValue.EnvolvedObject.DataBeanProperties;
          setLista(resp.DataBeanProperties.ObjectValue.Childs);
          _single.setCacheItem('getCacheItem_' + type, JSON.stringify(resp.DataBeanProperties.ObjectValue.Childs));
        }
        setLoading(false);
      });

    }
  };
  const importHealthIDCatalog = () => {
    //console.log(entailment.bean);
    imp.instance.importHealthIDCatalog(typetwo, imp.bean.Media, imp.bean.MediaContext, null).then(
      (resp: any) => {

        setModaladddoc({ ...modaladddoc, "view": false });
      }
    ).catch(err => {
      toast.error(err);
    })

  }
  const veradd = () => {
    setModaladddoc({ ...modaladddoc, "view": true });

  }
  const getHealthIDByName = () => {
    setLoading(true);
    service.getHealthIDByName(type, txt).subscribe((resp: any) => {
      //console.log(resp);

      if (resp.DataBeanProperties.ObjectValue) {
        let arbol: any = resp.DataBeanProperties.ObjectValue;
        let lis = resp.DataBeanProperties.ObjectValue;

        lis.forEach((element: any) => {

          element.EnvolvedObject = element;
        });
        //console.log(lis);

        setLista(lis);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const getSeparator = () => {

    localStorage.setItem('separador', '-');
    // service.getBudgetIDSeparator().subscribe(
    //   (resp: any) => {
    //     let separador = resp.DataBeanProperties.ObjectValue;
    //     localStorage.setItem('separador', separador);
    //   }
    // );

  }


  useEffect(() => {
    getListatree();
  }, [type])

  return (
    <>
      <div className="row mb-4">
        {isExpensive ?
          <div className="col-md-4">
            <SelectExpensiveBudgetIDType year={year} idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
          </div>
          :
         <>
          <div className="col-md-6">
            <label> Tipos de Catálogos de Códigos de Salud</label>
            <select
              // disabled={tipoPresupuesto ? true : false} 
              className="form-select" value={type} onChange={(e) => { setType(parseInt(e.target.value)) }}>
              <option value={0}>...</option>
              {listaType.length > 0 &&
                listaType.map((item: any, index: number) => {
                  return (
                    <option key={index} value={item.DataBeanProperties.IDHealthIDType}>{item.DataBeanProperties.Name}</option>
                  )
                })
              }
            </select>
          </div>
          {crud && <>
          <div className="col-md-6 mt-4 p-2">
              <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                Importar Códigos de Clasificación
              </BasicButton>
            </div>
          
          </>}
         </>
        }
        {type > 0 &&
          <>
            <div className="col-md-6">
              <label>Nombre</label>
              <input type="text" name="name" className="form-control" value={txt} onChange={(e) => { setTxt(e.target.value) }} />
            </div>
            <div className="col-md-2 mt-3 p-3">
              <BasicButton icon="" clase="success" eventClick={getHealthIDByName}>Buscar</BasicButton>
            </div>
          </>

        }

        {type && edit ?
          <div className="row">
            <div className="col-md-12 d-flex justify-content-end">
              <button title={"Agregar"} type="button" className="btn btn-icon " onClick={() => { setBean({}); setModalAdd({ ...modalAdd, "view": true }) }}>
                <i className={"ri-file-add-line"} style={{ fontSize: "15px" }} ></i>
              </button>
            </div>
          </div>
          :
          null
        }

      </div>
      <div className="row">
        <div className="col">
          {lista.length === 0 && type != 0 &&
            <ButtonHealthID
              idType={type}
              id={0}
              bean={{}}
              updateEvent={() => {
                getListatree();
              }}
            />
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ul className="list-group" key={'root-budget'}>
            {lista.length > 0 &&
              lista.map((item: any) => {
                return (
                  <li className="list-group-item itemh" onClick={() => { setBean(item.EnvolvedObject.DataBeanProperties) }} key={item.EnvolvedObject.DataBeanProperties.IDLn}>
                    {edit &&
                      <ButtonHealthID
                      json={item.EnvolvedObject.DataBeanProperties.JsonCode}
                        idType={type}
                        id={item.EnvolvedObject.DataBeanProperties.IDLn}
                        bean={item.EnvolvedObject.DataBeanProperties}
                        updateEvent={() => {
                          getListatree();
                        }}
                      />
                    }
                    <strong className={idchild === item.EnvolvedObject.DataBeanProperties.IDLn ? 'cursor treeselect' : 'cursor'} onClick={() => {
                      const selected = item.EnvolvedObject.DataBeanProperties.IDLn;
                      setIDchild(item.EnvolvedObject.DataBeanProperties.IDLn);
                       if (onSelect) {
                              onSelect(selected);
                           }
                      localStorage.setItem('BudgetID', JSON.stringify(item.EnvolvedObject.DataBeanProperties));
                    }}>
                      {/* <strong style={{marginLeft:'15px'}}>{item.EnvolvedObject.DataBeanProperties.BudgetViewCode} </strong>  */}
                      <strong style={{ marginLeft: '15px' }}>{item.EnvolvedObject.DataBeanProperties.JsonCode} </strong>
                      <small>{item.EnvolvedObject.DataBeanProperties.Name}</small>
                    </strong>

                    <span className="badge bg-success ms-1">{item.ChildrenCount}</span>

                    {(idchild === item.EnvolvedObject.DataBeanProperties.IDLn) &&

                      <>
                        <HealthIDChilds _type={type} idChild={idchild} edit={edit} editBean={(item: any) => { setBean(item) }} />
                      </>
                    }
                  </li>
                );
              })}
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={createBean}>
            <div className="row">
              <div className="col-md-12">
                <label>Código</label>
                <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, "Code": e.target.value }) }} />
              </div>
              <div className="col-md-6">
                <label>Utilizar Prefijo para Documento</label>
                    <BasicSwitch label="" estado={bean.UseDocumentMnemonic} eventChange={(e) => { setBean({ ...bean, "UseDocumentMnemonic": e }) }} />
              </div>
              {bean.UseDocumentMnemonic && <>
              <div className="col-md-6">
                <label>Prefijo de Documento</label>
                <input type="text" className="form-control" value={bean.DocumentMnemonic} onChange={(e) => { setBean({ ...bean, "DocumentMnemonic": e.target.value }) }} />
              </div>
              </>}
              <div className="col-md-12">
                <label >Nombre</label>
                <textarea className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, "Name": e.target.value }) }} />
              </div>
            </div>
          </Modal>
          <Modal modal={modaladddoc} updateModal={setModaladddoc} eventModal={importHealthIDCatalog}>
            <>
              <div className="row">
                <div className="col-md-12">
                  <label> Tipos de Catálogos de Códigos de Salud</label>
                  <select
                    // disabled={tipoPresupuesto ? true : false} 
                    className="form-select" value={typetwo} onChange={(e) => { setTypetwo(parseInt(e.target.value)) }}>
                    <option value={0}>...</option>
                    {listaType.length > 0 &&
                      listaType.map((item: any, index: number) => {
                        return (
                          <option key={index} value={item.DataBeanProperties.IDHealthIDType}>{item.DataBeanProperties.Name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-md-12">
                  <FileInput
                    Media={imp.bean.Media}
                    MediaContext={imp.bean.MediaContext}
                    directory='Rate'
                    label='Archivo'
                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                    onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                  ></FileInput>
                </div>
              </div>
            </>
          </Modal>
        </div>
      </div>
    </>
  );
};
